import React from 'react'
import classNames from 'classnames'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import DescriptionMDS from '@toasttab/shared/src/components/molecules/DescriptionMDS/DescriptionMDS'

interface NewsTwoColumnContentProps {
  content?: any
  image?: any
}

const NewsTwoColumnContent = ({
  content,
  image
}: NewsTwoColumnContentProps) => {
  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  } as Intl.DateTimeFormatOptions

  const dateCss = classNames('text-secondary font-sansPro !font-normal pb-6')

  return (
    <div
      className='py-5 w-full grid grid-cols-1 sm:grid-cols-2 grid-cols-50/50 gap-10'
      data-testid='NewsTwoColumnContent'
    >
      {content ? (
        <DescriptionMDS classes='text-xs [&_p]:!text-xs' content={content} />
      ) : null}
      {image ? (
        <Image
          imageAlt={image?.title}
          objectCover={false}
          url={image?.file?.url}
        />
      ) : null}
    </div>
  )
}

export default NewsTwoColumnContent
